import React from 'react';
import { Fade, Box } from '@mui/material';
import { useLocation } from 'react-router-dom';

/**
 * Soft fade-in on top-level route change. Keyed by the first path segment so
 * sub-route changes (e.g. picking a different mailbox within `/`) don't keep
 * re-fading mid-interaction.
 */
export function RouteTransition({ children, timeout = 220 }: { children: React.ReactNode; timeout?: number }) {
  const location = useLocation();
  const transitionKey = React.useMemo(() => {
    const segments = location.pathname.split('/').filter(Boolean);
    return segments[0] || '/';
  }, [location.pathname]);

  return (
    <Fade key={transitionKey} in appear timeout={timeout}>
      <Box sx={{ minHeight: '100%' }}>{children}</Box>
    </Fade>
  );
}
